import styled from '@emotion/styled';

export const Container = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 26,
  padding: '26px 16px',
  backgroundColor: props.theme.colors.white,
}));

export const Title = styled.div((props) => ({
  fontSize: 14,
  fontWeight: 500,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
  textAlign: 'center',
}));

export const Wrapper = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const Item = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const ItemVertical = styled(Item)((props) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const ItemName = styled.span((props) => ({
  fontSize: 12,
  fontWeight: 500,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
}));

export const ItemValue = styled.span((props) => ({
  fontSize: 12,
  fontWeight: 400,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
}));

export const ItemValueInactive = styled(ItemValue)((props) => ({
  color: props.theme.colors.inactive,
}));

export const Delimiter = styled.div((props) => ({
  height: 0.5,
  background: props.theme.colors.container.tertiary,
  width: '100%',
}));

export const Logo = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  fontSize: 12,
  fontWeight: 400,
  color: props.theme.colors.inactive,
  fontFamily: props.theme.fonts.primary,
}));

export const OrderSection = styled.div((props) => ({
  marginBottom: 12,
}));

export const TotalOrderSection = styled(OrderSection)((props) => ({
  marginBottom: 0,
  marginTop: 12,
}));
